export const CREATE_PAGE = 'planning/CREATE_PAGE';
export const FETCH_DATA_SUCCESS = 'planning/FETCH_DATA_SUCCESS';
export const SET_REQUIRED_FILTERS = 'planning/SET_REQUIRED_FILTERS';
export const SET_ERROR = 'planning/SET_ERROR';
export const SET_CALENDAR_MODE = 'planning/SET_CALENDAR_MODE';
export const SET_SELECTED_DAY = 'planning/SET_SELECTED_DAY';
export const SET_SELECTED_WEEK = 'planning/SET_SELECTED_WEEK';
export const SET_SELECTED_MONTH = 'planning/SET_SELECTED_MONTH';
export const FETCHING_DATA = 'planning/FETCHING_DATA';
